import { Buffer } from 'buffer';
import { isEmpty, nopString } from '../common/mod.js';
export function fromJson(value) {
    if (isEmpty(value)) {
        return value;
    }
    return JSON.parse(value);
}
export function toJson(value) {
    return JSON.stringify(value);
}
export function fromBase64(value) {
    if (!value) {
        return nopString;
    }
    return Buffer.from(value, 'base64').toString('binary');
}
export function toBase64(value) {
    if (!value) {
        return nopString;
    }
    return Buffer.from(value, 'binary').toString('base64');
}
export { fromByteArray as fromByteArrayNext, toByteArray as toByteArrayNext } from 'base64-js';
export function fromByteArray(value) {
    const array = 'buffer' in value ? value : new Uint8Array(value);
    let string = nopString;
    for (let i = 0; i < array.byteLength; ++i) {
        string += String.fromCharCode(array[i]);
    }
    return toBase64(string);
}
export function toByteArray(value) {
    const string = fromBase64(value);
    const array = new Uint8Array(string.length);
    for (let i = 0; i < string.length; ++i) {
        array[i] += string.charCodeAt(i);
    }
    return array;
}
//# sourceMappingURL=encoding.js.map